import { gql } from '@apollo/client';

const GET_PRODUCTS = gql`
  query products($params: QueryParams, $name: String) {
    products(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
        description
        type
        variants {
          id
          title
          img
          description
          price
          isPrimaryVariant
          product {
            id
            name
            description
          }
        }
      }     
    }
  }
`;

const CREATE_CATEGORY = gql`
  mutation CreateCategory($category: CategoryCreateInput!, $productCategories: [ID]) {
    createCategory(category: $category, productCategories: $productCategories) {
     id  
    }
  }
`;

export { GET_PRODUCTS, CREATE_CATEGORY }
